var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "div",
        { staticClass: "create-store-based-marketing-title" },
        [_c("CustomBreadcrumb")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "marketing-head-border" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("el-input", {
            attrs: { maxlength: "255", "show-word-limit": "" },
            on: {
              blur: function($event) {
                return _vm.blurInput($event)
              }
            },
            model: {
              value: _vm.createForm.campaignName,
              callback: function($$v) {
                _vm.$set(_vm.createForm, "campaignName", $$v)
              },
              expression: "createForm.campaignName"
            }
          }),
          _vm._v(" "),
          _vm.campaignNameError
            ? _c("div", { staticClass: "tips-error" }, [
                _vm._v("Please fill in Campaign Name")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "el-select",
            {
              on: { change: _vm.changeMarketingCycle },
              model: {
                value: _vm.createForm.marketingCycle,
                callback: function($$v) {
                  _vm.$set(_vm.createForm, "marketingCycle", $$v)
                },
                expression: "createForm.marketingCycle"
              }
            },
            _vm._l(_vm.marketingCycleList, function(item) {
              return _c("el-option", {
                key: item.label,
                attrs: { label: item.label, value: item.label }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._l(_vm.typeList, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                class: {
                  type: _vm.createForm.typeList.indexOf(item.title) < 0,
                  "type-selected":
                    _vm.createForm.typeList.indexOf(item.title) > -1
                },
                on: {
                  click: function($event) {
                    return _vm.changeType(item)
                  }
                }
              },
              [
                _c("div", { staticClass: "type-img" }, [
                  _c("img", { attrs: { src: item.img } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "type-right" }, [
                  _c("div", { staticClass: "type-title" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "type-subtitle" }, [
                    _vm._v(_vm._s(item.subtitle))
                  ])
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._l(_vm.sendUserChoiceList, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "send-user-choice-row" },
          [
            _c(
              "el-select",
              {
                on: {
                  change: function($event) {
                    return _vm.changeSendType(item, index)
                  }
                },
                model: {
                  value: item.sendType,
                  callback: function($$v) {
                    _vm.$set(item, "sendType", $$v)
                  },
                  expression: "item.sendType"
                }
              },
              _vm._l(_vm.sendTypeList, function(item) {
                return _c("el-option", {
                  key: item,
                  attrs: { label: item, value: item }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                on: { change: _vm.changeStoreNumber },
                model: {
                  value: item.storeNumber,
                  callback: function($$v) {
                    _vm.$set(item, "storeNumber", $$v)
                  },
                  expression: "item.storeNumber"
                }
              },
              _vm._l(_vm.storeNumberList, function(item) {
                return _c("el-option", {
                  key: item.label,
                  attrs: { label: item.label, value: item.label }
                })
              }),
              1
            ),
            _vm._v(" "),
            item.isShowStoreType
              ? _c(
                  "el-select",
                  {
                    attrs: { filterable: "" },
                    on: {
                      change: function($event) {
                        return _vm.changeStoreType(item, index)
                      }
                    },
                    model: {
                      value: item.storeType,
                      callback: function($$v) {
                        _vm.$set(item, "storeType", $$v)
                      },
                      expression: "item.storeType"
                    }
                  },
                  _vm._l(_vm.storeTypeList, function(item) {
                    return _c("el-option", {
                      key: item,
                      attrs: { label: item, value: item }
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            item.recommendationsStore
              ? _c(
                  "div",
                  {
                    staticClass: "recommendations-store-border",
                    on: {
                      click: function($event) {
                        return _vm.gotoReport(item.recommendationsStore)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "recommendations-store-img" }, [
                      _c("img", {
                        attrs: { src: item.recommendationsStore.mainImg }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "recommendations-store-right" }, [
                      _c("div", { staticClass: "recommendations-store-tips" }, [
                        _vm._v("The store sample")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "recommendations-store-name" }, [
                        _vm._v(_vm._s(item.recommendationsStore.storeName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "recommendations-store-address" },
                        [_vm._v(_vm._s(item.recommendationsStore.storeAddress))]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            index !== 0
              ? _c(
                  "div",
                  {
                    staticClass: "delete-action",
                    on: {
                      click: function($event) {
                        return _vm.deleteRow(item, index)
                      }
                    }
                  },
                  [_c("i", { staticClass: "el-icon-delete" })]
                )
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.sendUserChoiceList.length < 5
        ? _c(
            "div",
            {
              staticClass: "add-send-user-choice",
              on: { click: _vm.addSendUser }
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom-border" },
        [
          _c("div", { staticClass: "bottom-border-top" }, [
            _c("div", { staticClass: "bottom-border-top-title" }, [
              _vm._v("Total")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom-border-top-content" },
              _vm._l(_vm.totalStoreTypeList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "bottom-border-top-row" },
                  [
                    _vm._v("\n          Send "),
                    _c("span", [_vm._v(_vm._s(item.storeType))]),
                    _c("span", [_vm._v(_vm._s(item.storeTypeNumber))]),
                    _vm._v(" Stores.\n        ")
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "bottom-border-service-fee" }, [
            _c("div", { staticClass: "bottom-border-service-fee-title" }, [
              _vm._v("Service fees:")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bottom-border-service-fee-content" }, [
              _c("div", { staticClass: "bottom-border-service-fee-total" }, [
                _vm._v("Total:"),
                _c("span", [
                  _vm._v("$" + _vm._s(Number(_vm.serviceFee.total).toFixed(2)))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bottom-border-service-fee-discount" }, [
                _vm._v("Discount:"),
                _c("span", [_vm._v(_vm._s(_vm.serviceFee.discount))]),
                _vm._v("OFF")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bottom-border-service-fee-payable" }, [
                _vm._v("Total payable:"),
                _c("span", [
                  _vm._v(
                    "$" + _vm._s(Number(_vm.serviceFee.totalPayable).toFixed(2))
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottom-action" }, [
            _c(
              "div",
              { staticClass: "bottom-action-next", on: { click: _vm.preview } },
              [_vm._v("Next")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bottom-action-cancle",
                on: { click: _vm.cancel }
              },
              [_vm._v("Cancel")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisibleDialog,
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.previewVisibleDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "preview-dialog-border" }, [
            _vm.previewType === 1
              ? _c("div", { staticClass: "preview-dialog-next" }, [
                  _c("div", { staticClass: "preview-dialog-tips" }, [
                    _vm._v("Confirm submission")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "preview-dialog-form" }, [
                    _c("div", { staticClass: "preview-dialog-row" }, [
                      _c("div", { staticClass: "preview-dialog-row-label" }, [
                        _vm._v("Campaign Name")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "preview-dialog-row-value" }, [
                        _vm._v(_vm._s(_vm.createForm.campaignName))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "preview-dialog-row" }, [
                      _c("div", { staticClass: "preview-dialog-row-label" }, [
                        _vm._v("Marketing Cycle")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "preview-dialog-row-value" }, [
                        _vm._v(_vm._s(_vm.createForm.marketingCycle))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "preview-dialog-row" }, [
                      _c("div", { staticClass: "preview-dialog-row-label" }, [
                        _vm._v("Type")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "preview-dialog-row-value" },
                        _vm._l(_vm.createForm.typeList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "preview-dialog-row-value-border"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "preview-dialog-row-value-title"
                                },
                                [_vm._v(_vm._s(item))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "preview-dialog-row-value-content"
                                },
                                [
                                  _vm._v(
                                    "Send a targeted message to your contacts through " +
                                      _vm._s(item) +
                                      "."
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              index !== _vm.createForm.typeList.length - 1
                                ? _c("el-divider")
                                : _vm._e()
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "preview-dialog-row" }, [
                      _c("div", { staticClass: "preview-dialog-row-label" }, [
                        _vm._v("Total")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "preview-dialog-row-value" },
                        _vm._l(_vm.totalStoreTypeList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "preview-dialog-row-value-border"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "preview-dialog-row-value-store-type"
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(item.storeType))]),
                                  _c("span", [
                                    _vm._v(_vm._s(item.storeTypeNumber))
                                  ]),
                                  _vm._v(" stores")
                                ]
                              ),
                              _vm._v(" "),
                              _c("el-divider")
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottom-border-service-fee" }, [
                      _c(
                        "div",
                        { staticClass: "bottom-border-service-fee-title" },
                        [_vm._v("Service fees:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bottom-border-service-fee-content" },
                        [
                          _c(
                            "div",
                            { staticClass: "bottom-border-service-fee-total" },
                            [
                              _vm._v("Total:"),
                              _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      Number(_vm.serviceFee.total).toFixed(2)
                                    )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "bottom-border-service-fee-discount"
                            },
                            [
                              _vm._v("Discount:"),
                              _c("span", [
                                _vm._v(_vm._s(_vm.serviceFee.discount))
                              ]),
                              _vm._v("OFF")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "bottom-border-service-fee-payable"
                            },
                            [
                              _vm._v("Total payable:"),
                              _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      Number(
                                        _vm.serviceFee.totalPayable
                                      ).toFixed(2)
                                    )
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.submitLoading,
                            expression: "submitLoading"
                          }
                        ],
                        staticClass: "bottom-action"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "bottom-action-next",
                            on: { click: _vm.submit }
                          },
                          [_vm._v("Submit")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "bottom-action-cancle",
                            on: { click: _vm.returnToEdit }
                          },
                          [_vm._v("Return To Edit")]
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.previewType === 2
              ? _c("div", { staticClass: "preview-dialog-cancle" }, [
                  _c("div", { staticClass: "preview-dialog-cancle-title" }, [
                    _vm._v(
                      "If you cancel, your entries will not be saved. Are you sure you want to cancel?"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottom-action" }, [
                    _c(
                      "div",
                      {
                        staticClass: "bottom-action-next",
                        on: { click: _vm.confirm }
                      },
                      [_vm._v("Confirm")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "bottom-action-cancle",
                        on: { click: _vm.returnToEdit }
                      },
                      [_vm._v("Cancle")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.previewType === 3
              ? _c("div", { staticClass: "preview-dialog-success" }, [
                  _c("div", { staticClass: "preview-dialog-success-title" }, [
                    _vm._v("Submission Successful.")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "preview-dialog-success-subtitle" },
                    [
                      _vm._v(
                        "Please be patient, our sales team will contact you within 48 hours"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottom-action" }, [
                    _c(
                      "div",
                      {
                        staticClass: "bottom-action-next",
                        on: { click: _vm.goBack }
                      },
                      [_vm._v("Back to Home")]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "campaign-name" }, [
      _vm._v("Campaign Name"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marketing-cycle" }, [
      _vm._v("Marketing Cycle"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "type-label" }, [
      _vm._v("Type"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "send-user-choice" }, [
      _vm._v("Send User Choices"),
      _c("span", [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748acd48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748acd48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/store-based-marketing/store-based-marketing-create.vue
// module id = u8Cx
// module chunks = 2